/** @format */

import React, { useState } from 'react';
import config from 'config';
import Button from 'react-bootstrap/Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from 'components/Modals/CommonModal';
import { sendFriLansEmail } from 'stateContainer/actions';
import { useTranslation } from 'react-i18next';

export default function GridItem({ item, index }) {
  const {
    data: { userData }
  } = useSelector((state) => state.session);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  let brokerProfileUrl = `${t('lang_route:common_broker_profile')}/?profileId=${
    userData.brokerId
  }`; //`${config.app.friaMaklareWebOriginUrl}/brokerprofile?profileId=${userData.brokerId}`;

  if (userData.brokerSlug) {
    brokerProfileUrl = `${t('lang_route:common_broker_profile')}/${
      userData.brokerSlug
    }`;
  }

  function getButtonFunc() {
    switch (index) {
      case 0:
        return window.open(brokerProfileUrl, '_blank', 'noopener').focus();
      case 1:
        return window
          .open(config.app.vitecLoginUrl, '_blank', 'noopener')
          .focus();

      case 2:
        return handleShow();
      case 3:
        return window
          .open(config.app.personalEmailUrl, '_blank', 'noopener')
          .focus();
      default:
        break;
    }
  }

  function sendEmail() {
    const { email, firstName, lastName, ssn } = userData;

    const data = {
      data: {
        firstName,
        lastName,
        brokerEmail: email,
        ssn
      }
    };

    dispatch(sendFriLansEmail(data));
    handleClose();
  }

  return (
    <>
      <div className='dashboard-grid-card'>
        <div>
          <img
            src={item.logoUrl}
            alt='Main logo'
            className='dashboard-grid-logo-image'
          />
          <p className='text1r'>{item.tagline}</p>
        </div>

        <Button
          className={'btn btn-pink dashboard-grid-button'}
          onClick={() => getButtonFunc()}>
          {item.btnText}
          <FontAwesomeIcon icon={faLongArrowRight} size='lg' />
        </Button>
      </div>
      {index === 2 && (
        <CommonModal
          showModal={showModal}
          handleClose={handleClose}
          header={t('lang_broker:dashboard:accessStation:frilans_finans:text')}
          body={item.modal_body}
          button_1={item.modal_button_1}
          button_2={item.modal_button_2}
          handleBtn1={() =>
            window
              .open(config.app.friLansFinansLoginUrl, '_blank', 'noopener')
              .focus()
          }
          handleBtn2={() => sendEmail()}
          centerButtons
        />
      )}
    </>
  );
}
